import {
    SectionFooter,
    SectionBody,
} from '@/components/molecules/PremiumOverview'
import { Header } from './Header'
import { useTranslation } from 'react-i18next'
import totalEmissionsDonutChart from '/assets/total-emissions-donut.png'
import ghgEmissionsReport from '/assets/ghg-emissions-report.png'
import sustainabilityFilters from '/assets/sustainability-filters.png'
import exportReports from '/assets/export-reports.png'
import dataManagement from '/assets/data-management.png'
import { Icon } from '@/components/atoms'
import { FormattedI18nString } from '@/utils/FormattedI18nString'

const boldClassName = 'capitalize'

export function PremiumOverviewContainer() {
    const { t } = useTranslation('translations')

    const sections = [
        {
            imageProps: { fgSrc: totalEmissionsDonutChart },
            textProps: {
                title: t('sustainability.premiumOverview.firstSection.title'),
                subtitle: t(
                    'sustainability.premiumOverview.firstSection.subtitle'
                ),
                list: [
                    {
                        icon: <Icon name="check" />,
                        text: (
                            <FormattedI18nString
                                boldClassName={boldClassName}
                                i18nKey="sustainability.premiumOverview.firstSection.firstListItem"
                            />
                        ),
                    },
                    {
                        icon: <Icon name="check" />,
                        text: (
                            <FormattedI18nString
                                boldClassName={boldClassName}
                                i18nKey="sustainability.premiumOverview.firstSection.secondListItem"
                            />
                        ),
                    },
                    {
                        icon: <Icon name="check" />,
                        text: (
                            <FormattedI18nString
                                boldClassName={boldClassName}
                                i18nKey="sustainability.premiumOverview.firstSection.thirdListItem"
                            />
                        ),
                    },
                ],
            },
            reverse: false,
        },
        {
            imageProps: { fgSrc: ghgEmissionsReport },
            textProps: {
                title: t('sustainability.premiumOverview.secondSection.title'),
                subtitle: t(
                    'sustainability.premiumOverview.secondSection.subtitle'
                ),
                list: [
                    {
                        icon: <Icon name="check" />,
                        text: (
                            <FormattedI18nString
                                boldClassName={boldClassName}
                                i18nKey="sustainability.premiumOverview.secondSection.firstListItem"
                            />
                        ),
                    },
                    {
                        icon: <Icon name="check" />,
                        text: (
                            <FormattedI18nString
                                boldClassName={boldClassName}
                                i18nKey="sustainability.premiumOverview.secondSection.secondListItem"
                            />
                        ),
                    },
                    {
                        icon: <Icon name="check" />,
                        text: (
                            <FormattedI18nString
                                boldClassName={boldClassName}
                                i18nKey="sustainability.premiumOverview.secondSection.thirdListItem"
                            />
                        ),
                    },
                ],
            },
            reverse: true,
        },
        {
            imageProps: { fgSrc: sustainabilityFilters },
            textProps: {
                title: t('sustainability.premiumOverview.thirdSection.title'),
                subtitle: t(
                    'sustainability.premiumOverview.thirdSection.subtitle'
                ),
            },
            reverse: false,
        },
        {
            imageProps: { fgSrc: exportReports },
            textProps: {
                title: t('sustainability.premiumOverview.forthSection.title'),
                subtitle: t(
                    'sustainability.premiumOverview.forthSection.subtitle'
                ),
            },
            reverse: true,
        },
        {
            imageProps: { fgSrc: dataManagement },
            textProps: {
                title: t('sustainability.premiumOverview.fifthSection.title'),
                subtitle: t(
                    'sustainability.premiumOverview.fifthSection.subtitle'
                ),
            },
            reverse: false,
        },
    ]

    return (
        <div data-testid="premium-overview-container" className="-mt-6">
            <Header />
            {sections.map((section, idx) => (
                <SectionBody
                    key={idx}
                    className={section.reverse ? 'bg-white' : 'bg-neutral-50'}
                    section={section}
                />
            ))}
            <SectionFooter
                title={t('sustainability.premiumOverview.footer.title')}
                subtitle={
                    <>
                        <span className="text-body-medium">
                            <FormattedI18nString
                                boldClassName="!font-normal"
                                i18nKey="sustainability.premiumOverview.footer.contact"
                            />
                        </span>
                        <a
                            href="mailto:contact@myenergynetwork.com"
                            className="font-semibold text-blue-200"
                        >
                            {t('sustainability.premiumOverview.footer.email')}
                        </a>
                        .
                    </>
                }
            />
        </div>
    )
}
